import { colors } from '@sweep-io/sweep-design';
import { Divider } from '@mui/material';

const HeaderDivider = ({ color = colors.night[700] }: { color?: string }) => (
  <Divider
    orientation="vertical"
    sx={{
      height: '21px',
      borderColor: color,
    }}
  />
);

export default HeaderDivider;
